import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import MobileBookBar from "./MobileBookBar";

export default function PublicLayout({ children }) {
  const { settings } = useApp();
  const { pathname } = useLocation();
  const wa = settings?.contact?.whatsapp;
  const showBar = pathname !== "/book";
  return (
    <div className={`min-h-screen flex flex-col bg-background ${showBar ? "pb-20 sm:pb-0" : ""}`}>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ChatWidget lifted />
      {wa && (
        <a
          href={`https://wa.me/${wa}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float"
          className={`fixed bottom-6 end-6 z-50 place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform hidden sm:grid`}
          aria-label="WhatsApp"
        >
          <MessageCircle className="h-7 w-7" />
        </a>
      )}
      {showBar && <MobileBookBar />}
    </div>
  );
}
